import { Link } from "react-router-dom";
import { topics } from "@/mocks/gossip";

export default function TopicsSection() {
  return (
    <section aria-labelledby="topics-title" className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-primary-600 uppercase mb-2">
              <span className="w-4 h-px bg-primary-500"></span>
              Collections
            </span>
            <h2 id="topics-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              专题合集 · 按场景串联着看
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              单个片段看不过瘾？我们按活动场景把同类现场画面编成专题，从准备到收场一次看完。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {topics.map((topic, index) => (
            <article
              key={topic.id}
              className={`group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${
                index === 0 ? "sm:col-span-2" : ""
              }`}
            >
              <div className={`relative w-full overflow-hidden bg-secondary-200 ${index === 0 ? "h-52 md:h-64" : "h-44"}`}>
                <img
                  src={topic.cover}
                  alt={`${topic.title} 专题封面`}
                  title={`${topic.title} 视频吃瓜 专题合集`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent"></div>
                <div className="absolute bottom-0 left-0 w-full p-4 md:p-5">
                  <span className="inline-flex items-center gap-1 rounded-full bg-accent-500/90 px-2.5 py-1 text-xs font-medium text-foreground-950 mb-2">
                    <i className="ri-stack-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    {topic.count} 段视频
                  </span>
                  <h3 className="font-heading text-base md:text-lg font-bold text-background-50">{topic.title}</h3>
                </div>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <p className="flex-1 text-sm leading-relaxed text-foreground-600">{topic.subtitle}</p>
                <Link
                  to={`/category/${topic.category}`}
                  className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 cursor-pointer transition-colors hover:text-primary-700"
                >
                  浏览同类内容
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}